import delay from './delay';

// This file mocks a web API by working with the hard-coded data below.
// It uses setTimeout to simulate the delay of an AJAX call.
// All calls return promises.
const accounts = [
  {
    id: "id-1",
    email: "first email address",
    accountName: 'My Acc 1',
    address: 'address 1',
    adminName: 'admin 1',
    mobileNumber: '1111234',
    password: "myPAss1"
  },
  {
    id: "id-2",
    email: "second email here",
    accountName: 'My Acc 2',
    address: 'address 2',
    adminName: 'admin 2',
    mobileNumber: '2221234',
    password: "myPAss2"
  },
  {
    id: "id-3",
    email: "third email address here",
    accountName: 'My Acc 3',
    address: 'address 3',
    adminName: 'admin 3',
    mobileNumber: '33331234',
    password: "myPAss3"
  },
  {
    id: "id-4",
    email: "forth email ",
    accountName: 'My Acc 4',
    address: 'address 4',
    adminName: 'admin 4',
    mobileNumber: '44441234',
    password: "myPAss4"
  }
];

//This would be performed on the server in a real app. Just stubbing in.
// const generateId = () => {
//   return Math.floor((1 + Math.random()) * 0x10000)
//     .toString(16)
//     .substring(1);
// };

class AccountApi {
  static getAllAccounts() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if(!accounts) {
          reject('No Accounts found');
        }
        resolve(Object.assign([], accounts));
      }, delay);
    });
  }

  static createAccount(registration) {
    // to avoid manipulating original object
    registration = Object.assign({},registration);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Simulate server-side validationaccount
        const minCourseTitleLength = 6;
        if (registration.password.length < minCourseTitleLength) {
          reject(`Password must be at least ${minCourseTitleLength} characters.`);
        }

        //Just simulating creation here.
        //The server would generate ids and watchHref's for new account in a real app.
        //Cloning so copy returned is passed by value rather than by reference.
        const newAccount = {
          id: registration.id,
          email: registration.email,
          password: registration.password
        };
        accounts.push(newAccount);

        resolve(newAccount);
      }, delay);
    });
  }

  static updateAccount(account) {
    account = Object.assign({}, account); // to avoid manipulating object passed in.
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Simulate server-side validationaccount
        // const minCourseTitleLength = 6;
        // if (account.password.length < minCourseTitleLength) {
        //   reject(`Password must be at least ${minCourseTitleLength} characters.`);
        // }
        let newAcc;
        if (account.id) {
          newAcc = Object.assign(accounts.filter(data => account.id === data.id)[0], account);
          const existingAccountIndex = accounts.findIndex(a => a.id == account.id);
          accounts.splice(existingAccountIndex, 1, newAcc);
        } else {
          reject(`Account no found for id ${account.id}.`);
        }

        resolve(newAcc);
      }, delay);
    });
  }
}

export default AccountApi;



// WEBPACK FOOTER //
// ./src/api/mockAccountApi.js